// Compatibility exports for code paths created while Family & Friends were
// device-local. Family/Friend records now come from the backend family session
// and are handled as normal FamilyMember records.

export const MAX_MOBILE_FAMILY_FRIENDS = 15;

export const getMobileFamilyFriends = () => [];

export const addMobileFamilyFriend = () => ({
  success: false,
  error: 'Family & Friends are saved through the family account.',
  friends: [],
});

export const removeMobileFamilyFriend = () => [];

export const updateMobileFamilyFriend = () => null;

export const isMobileLocalFriend = () => false;

export const setActiveMobileFamilyFriend = () => null;

export const clearActiveMobileFamilyFriend = () => undefined;

export const getActiveMobileFamilyFriend = () => null;

export const attachActiveMobileFamilyFriend = (playData = {}) => playData;
